import * as React from "react";

import "./modal-service-sidebar.scss";

import {cx}                             from "emotion";
import {CSSTransition, TransitionGroup} from "react-transition-group";

import {Types} from "@Common/types";

import {chain} from "../../utils/fs";
import {cs} from "../../react/chain-services";
import {Static2} from "../../react/static-2";
import {UseState} from "../../react/use-state";
import {Fragment} from "react";

/**
 * @deprecated Use ModalService3 with sidebar: {} instead
 */
export const SidebarModalService:Types.Common.UiComponents.ModalServiceSidebar.SidebarModalService = (
    {
        className,
        key,
        next,
        onPassiveClose,
        render,
        service,
    }
) => cs(
    ["state", (_, next) => UseState({
        _key: key,
        getInitValue: () => ({show: undefined}),
        next,
    })],
    ["overlayDom", (_, next) => Static2({next})],
    ({overlayDom, state}) => <>
        {next({
            show: (params = true) => state.onChange({show: params}),
        })}

        {cs(
            ({}, next) => (
                <TransitionGroup component={Fragment}>
                    {next()}
                </TransitionGroup>
            ),
            ({}, next) => state.value.show && next(),

            ({}, next) => (
                <CSSTransition
                    classNames={"up"}
                    timeout={300}
                >
                    {next()}
                </CSSTransition>
            ),
            ["r", (_, next) => chain(
                (service || ((params, onChange, next) => next(render(params, onChange)))),
                (service) => service(state.value.show, (params) => state.onChange({show: params}), next)
            )],
            ["passiveClose", ({r}, next) => next(async () => {
                const hide = await (r.onPassiveClose || onPassiveClose || null)?.();
                if (hide !== false) {
                    state.onChange({show: false});
                }
            })],
            ({r, passiveClose}) => (
                <div
                    className={cx("modal-overlay-sidebar-r9g", className)}
                    onClick={(e) => {
                        if (e.target === overlayDom.get()) {
                            passiveClose();
                        }
                    }}
                    ref={ref => overlayDom.set(ref)}
                >
                    <div
                        className={cx("fixed-box", typeof r.size === "string" && r.size)}
                        style={{
                            ...typeof r.size === "number" && {
                                maxWidth: r.size * (window.innerWidth >= 1920 ? 1.43 : 1),
                            },
                        }}

                    >
                        <div className="content">
                            {r.content}
                        </div>
                    </div>
                </div>
            ),
        )}
    </>
);
